import React from 'react';
import { connect } from 'react-redux';
import pubSub from '../../util/pubSub';
import Sticky from '../Page/Sticky.jsx';

const mapStateToProps = state => ({
  headerHeight: state.events.headerHeight,
});

@connect(mapStateToProps)
export default class StickyUnderNav extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      notificationsOffset: 0,
    };
  }

  componentDidMount() {
    this.notificationsOffsetSubscription = pubSub.subscribe('notificationsOffsetChanged', offset => {
      this.setState({notificationsOffset: offset});
    });
  }

  componentWillUnmount() {
    this.notificationsOffsetSubscription.remove();
  }

  render() {
    const { notificationsOffset } = this.state;
    const offset = notificationsOffset + this.props.headerHeight;

    return (
      <Sticky offset={-offset} fixedWidth>
        <div style={{ top: offset }}>
          { this.props.children}
        </div>
      </Sticky>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Sidebar/StickyUnderNav.jsx